<template>
  <nuxt-link
    :to="localePath(`/tutorial/${_id}`)"
    :class="$style.item"
  >
    <div :class="$style.itemTitle">{{ title }}</div>
    <div :class="$style.itemText" v-html="excerpt"></div>
  </nuxt-link>
</template>

<script setup lang="ts">
import type { SinglePostParams } from './index';
const localePath = useLocalePath();

const props = defineProps<SinglePostParams>();
</script>

<style lang="scss" module>
  .item {
    display: flex;
    flex-direction: column;
    flex: 1;
    border-radius: 24px;
    background: #FFF;
    padding: 12px 12px 16px 12px;
    text-decoration: none;
    color: #596269;
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;

    &Title {
      color: #121E29;
      font-family: 'Gilroy';
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-bottom: 7px;
      margin-top: 18px;
    }

    &Text {
      margin-bottom: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;

      @media (max-width: 1023px) {
        -webkit-line-clamp: 8;
      }

      @media (max-width: 767px) {
        -webkit-line-clamp: 4;
      }
    }

    &Date {
      margin-top: 8px;
      color: #71787F;
      font-size: 14px;
    }

    &Cat {
      z-index: 2;
      position: absolute;
      top: 22px;
      left: 24px;
      display: flex;
      align-items: center;
      gap: 8px;
      height: 28px;
      padding: 7px 12px;
      border-radius: 14px;
      background: rgba(0, 0, 0, 0.15);
      backdrop-filter: blur(7.5px);
      color: #fff;
      font-family: 'Gilroy';
      font-size: 12px;
      font-weight: 400;

      svg {
        flex-shrink: 0;
        width: 10px;
        height: auto;
      }
    }

    &Thumb {
      position: relative;
      border-radius: 24px;
      overflow: hidden;
      height: 250px;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }
</style>